import { parsePhoneNumberFromString } from 'libphonenumber-js';

export const isPhoneNumberValid = (phone: string): boolean => {
  if (!phone || typeof phone !== 'string') return false;

  // Pokud je telefon bez p�edvolby, pou�ije se CZ jako v�choz�
  const phoneNumber = parsePhoneNumberFromString(phone, 'CZ');

  return !!phoneNumber && phoneNumber.isValid();
};

export const isEmailValid = (email: string): boolean => !!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.exec(email);
